import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { MODES_REQUIRING_ELEMENT } from './combat-consts';

export const heroCardDropRatesSectionSchema = (enums?: EnumParams) =>
  z.object({
    modifier: z
      .number()
      .min(-100)
      .max(1000)
      .refine(v => v !== 0, { message: 'Modifier cannot be 0' }),
    appliesTo: z.array(
      z
        .object({
          hero: enums ? z.enum(enums.HeroType).optional() : z.string().optional(),
          combatTag: enums ? z.enum(enums.CombatTagFull).optional() : z.string().optional(),
        })
        .refine(row => (row.hero !== undefined) !== (row.combatTag !== undefined), {
          message: 'Exactly one of hero or combatTag must be selected per row',
        }),
    ),
    inModes: z.array(
      z
        .object({
          gameMode: enums ? z.enum(enums.GameMode) : z.string(),
          element: enums ? z.enum(enums.CombatTag).optional() : z.string().optional(),
        })
        .refine(
          row => {
            const requiresElement = (MODES_REQUIRING_ELEMENT as readonly string[]).includes(
              row.gameMode,
            );
            return requiresElement ? row.element !== undefined : row.element === undefined;
          },
          {
            message:
              'Element is required for DailyDungeon and GuildBoss, and must be absent for other modes',
          },
        ),
    ),
  });
